import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InspectionService, ResponseInspectionPlanComment, BodyUpdateInspectionPlanComments, BodyPostInspectionPlanComments, BodyDeletInspectionPlanComment } from 'src/app/services/inspection.service';
import { MessageBannerServiceService } from '../services/message-banner-service.service';
import { SessionData } from '../localstorage/sessionData';
import { UserData } from 'src/app/interfaces/userInfo.interface';

@Component({
  selector: 'app-edit-component',
  templateUrl: './edit-component.component.html',
  styleUrls: ['./edit-component.component.scss']
})
export class EditComponentComponent implements OnInit {
  miCampo: FormControl = this.fb.control('', [
    Validators.required,
    Validators.minLength(5),
    Validators.maxLength(500)
  ]);
  user!: UserData;

  constructor(
    public dialogo: MatDialogRef<EditComponentComponent>,
    private popUpService: MessageBannerServiceService,
    @Inject(MAT_DIALOG_DATA) public data: {
      dataResponse?: ResponseInspectionPlanComment;
      dataPost?: BodyPostInspectionPlanComments;
    },
    private inspectionService: InspectionService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.miCampo.setValue(this.data.dataResponse?.comment ?? '');
    this.user = SessionData.getCurrentUser();
  }


  cerrarDialogo(): void {
    this.miCampo.setValue('');
    this.dialogo.close(false);
  }

  deleteComment() {
    const body: BodyDeletInspectionPlanComment = {
      id: this.data.dataResponse!.id,
      deletedById: this.user.id
    }
    this.dialogo.close();
    this.inspectionService.deletInspectionPlanComment(body).subscribe({
      next: (resp) => {
        console.log("⭕️--> ~ edit-component.component.ts:47 ~ EditComponentComponent ~ deleteComment ~ resp:", resp)
        location.reload();
      }, error: (err) => {
        console.log("⭕️--> ~ edit-component.component.ts:50 ~ EditComponentComponent ~ deleteComment ~ err:", err)
        this.popUpService.showMessage('ERROR', err.message, false, true, true);
      }
    })
  }
  createComment() {
    const updatedComment = this.miCampo.value;
    const body: BodyPostInspectionPlanComments = {
      ...this.data.dataPost!,
      comment: updatedComment,
      commentDate: new Date().toISOString(),
      createdById: this.user.id
    }
    console.log("⭕️--> ~ edit-component.component.ts:48 ~ EditComponentComponent ~ createComment ~ body:", body)

    this.dialogo.close();
    this.inspectionService.postInspectionPlanComments(body).subscribe({
      next: (resp) => {
        console.log("⭕️--> ~ edit-component.component.ts:51 ~ EditComponentComponent ~ updateComment ~ resp:", resp)
        location.reload();
      }, error: (err) => {
        console.log("⭕️--> ~ edit-component.component.ts:54 ~ EditComponentComponent ~ updateComment ~ err:", err)
        this.popUpService.showMessage('ERROR', err.message, false, true, true);
      }
    })

  }

  updateComment() {
    const updatedComment = this.miCampo.value;
    // console.log('Nuevo comment:', updatedComment);
    const body: BodyUpdateInspectionPlanComments = {
      id: this.data.dataResponse!.id,
      comment: updatedComment,
      modifiedById: this.user.id
    }
    this.dialogo.close();

    this.inspectionService.updateInspectionPlansComments(body).subscribe({
      next: (resp) => {
        console.log("⭕️--> ~ edit-component.component.ts:51 ~ EditComponentComponent ~ updateComment ~ resp:", resp)
        location.reload();
      }, error: (err) => {
        console.log("⭕️--> ~ edit-component.component.ts:54 ~ EditComponentComponent ~ updateComment ~ err:", err)
        this.popUpService.showMessage('ERROR', err.message, false, true, true);
      }
    })

  }

}
